import Colors from 'assets/Colors';
import Funcs from 'common/helpers/Funcs';
import SingleInstanceService from 'common/services/SingleInstanceService';
import React, { PureComponent } from 'react';
import { StyleSheet } from 'react-native';
import * as Animatable from 'react-native-animatable';
import Spinner from 'react-native-spinkit';
import DropAlert from '../views/DropAlert';

export default class ModalLoading extends PureComponent {
  static show(timeout = 10000, callbackReturnData) {
    if (!SingleInstanceService.ModalLoading || !SingleInstanceService.ModalLoading.Animatable) {
      Funcs.log('Loading instance not exist');
      return;
    }
    const fadeIn = { from: { opacity: 0 }, to: { opacity: 1 } };
    SingleInstanceService.ModalLoading.setState({ isVisible: true });
    SingleInstanceService.ModalLoading.Animatable.animate(fadeIn, 200);

    // Timeout 10s
    SingleInstanceService.ModalLoading.loadingTimeout = setTimeout(() => {
      Funcs.log('Loading timeout');
      if (callbackReturnData) {
        const data = callbackReturnData();
        if (data) DropAlert.warn('', 'Timeout with message: ' + data);
      }
      ModalLoading.hide();
    }, timeout);
  }

  static async hide() {
    if (!SingleInstanceService.ModalLoading || !SingleInstanceService.ModalLoading.Animatable) {
      Funcs.log('Loading instance not exist');
      return;
    }
    if (SingleInstanceService.ModalLoading.loadingTimeout) clearTimeout(SingleInstanceService.ModalLoading.loadingTimeout);
    const fadeIn = { from: { opacity: 1 }, to: { opacity: 0 } };
    await SingleInstanceService.ModalLoading.Animatable.animate(fadeIn, 200);
    SingleInstanceService.ModalLoading.setState({ isVisible: false });
  }

  static defaultProps = {
    spinnerSize: 40,
    spinnerType: 'Circle'
  };

  state = {
    isVisible: false
  };

  componentDidMount() {
    SingleInstanceService.ModalLoading = this;
  }

  componentWillUnmount() {
    if (this.loadingTimeout) clearTimeout(this.loadingTimeout);
    SingleInstanceService.ModalLoading = null;
  }

  render() {
    SingleInstanceService.ModalLoading = this;
    var { isVisible } = this.state;
    return (
      <Animatable.View ref={(ref) => (this.Animatable = ref)} style={isVisible ? styles.show : styles.hide}>
        <Spinner isVisible={true} size={this.props.spinnerSize} type={this.props.spinnerType} color={this.props.spinnerColor || Colors.text} />
      </Animatable.View>
    );
  }
}

const styles = StyleSheet.create({
  show: {
    backgroundColor: 'rgba(0, 0, 0, 0.25)',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center'
  },
  hide: {
    position: 'absolute',
    top: -100,
    width: 0,
    height: 0,
    opacity: 0
  }
});
